import { type NextPageWithLayout } from '@/pages/_app'

export const attachLayout = <P extends object>(
  Component: NextPageWithLayout<P>,
  getLayout: NonNullable<NextPageWithLayout<P>['getLayout']>,
): NextPageWithLayout<P> => {
  const Page: NextPageWithLayout<P> = (props) => <Component {...props} />

  Page.getLayout = getLayout

  return Page
}
